import React from "react";
import { MdScreenShare } from 'react-icons/md'
import { Link } from "react-router-dom";

const MarketingComp = () => {
  
  return (
    <>
      <h2 className="text-3xl text-center sm:text-left sm:text-4xl mt-10  text-lyellow sm:px-[2.3em] font-semibold">
        Share and Win
      </h2>
      <div className="flex flex-col justify-center items-center">
        <div className="w-full flex flex-col justify-between">
          <div className="flex justify-evenly flex-col md:flex-row mt-8">
            <div className="">
              <div className="space-y-4 text-white">
                <div className="flex flex-col items-center justify-between px-[5em] pb-5 pt-2">
                  <div className="block px-6 py-4 bg-black/50 rounded-t-2xl border border-black/20 shadow-md cursor-pointer w-[24em] sm:w-[30em] xl:w-[35em] ">
                    <div className="flex justify-between items-center">
                      <p className="text-lyellow text-sm md:text-xl font-semibold">
                        Share Grab A Bag
                      </p>
                    </div>
                  </div>

                  <div className="block p-6 bg-[#2a3137] border border-black/20 shadow-md cursor-pointer w-[24em] sm:w-[30em] xl:w-[35em] ">
                    <div className="flex flex-col justify-center space-y-5">
                      <div className="flex justify-start items-center">
                        <div>
                            <p className="text-lyellow text-xl font-semibold mr-10">Let's Go and Win</p>
                        </div>
                        <div>
                            <a href="/marketing" target="_blank" >

                                <MdScreenShare className="text-lyellow text-4xl font-semibold" />
                            </a>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div className="block p-6 bg-black/40 rounded-b-2xl border border-black/20 shadow-md mb-10 cursor-pointer w-[24em] sm:w-[30em] xl:w-[35em] ">
                    <div className="flex flex-col justify-center space-y-1">
                      <p className="font-semibold text-xl text-lyellow">
                        Details:
                      </p>
                      <div>
                          The Giveaway is open to all users of the platform. No Purchase is necessary Void where prohibited. Share on twitter and get a chance to win USDT. The more you share the higher your chances get.
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="flex justify-center items-center">
        <div className="w-11/12 h-[0.2px] border-t border-lyellow" />
      </div>
    </>
  );
};

export default MarketingComp;
